import { useHistory, useLocation } from "react-router-dom";
import { LinkTo } from "../../../constants/linkTo";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetHseColorsTabs = () => {

    return {
        [NAVBAR_TAB_NAMES.hsecolors_main]: {
            content: 'главная',
            linkTo: LinkTo.explore,
        },
        [NAVBAR_TAB_NAMES.hsecolors_catalog]: {
            active: false,
            content: 'каталог',
            disabled: true,
            linkTo: LinkTo.explore,
        },
        [NAVBAR_TAB_NAMES.hsecolors_community]: {
            active: false,
            content: 'сообщество',
            external: true,
            linkTo: 'https://art.hse.ru/?roistat_visit=1615114',
        },
        [NAVBAR_TAB_NAMES.hsecolors_education]: {
            active: false,
            content: 'образование',
            external: true,
            linkTo: 'https://design.hse.ru/dir/art',
        }
    }
}import { useHistory, useLocation } from "react-router-dom";
import { LinkTo } from "../../../constants/linkTo";
import { NAVBAR_TAB_NAMES } from "../const/navbarTabNames";

export const useGetHseColorsTabs = () => {

    return {
        [NAVBAR_TAB_NAMES.hsecolors_main]: {
            content: 'главная',
            linkTo: LinkTo.explore,
        },
        [NAVBAR_TAB_NAMES.hsecolors_catalog]: {
            active: false,
            content: 'каталог',
            disabled: true,
            linkTo: LinkTo.explore,
        },
        [NAVBAR_TAB_NAMES.hsecolors_community]: {
            active: false,
            content: 'сообщество',
            external: true,
            linkTo: 'https://art.hse.ru/?roistat_visit=1615114',
        },
        [NAVBAR_TAB_NAMES.hsecolors_education]: {
            active: false,
            content: 'образование',
            external: true,
            linkTo: 'https://design.hse.ru/dir/art',
        }
    }
}